import { Toggle as AToggle } from '@ark-ui/solid/toggle';
import { ToggleGroup as AToggleGroup } from '@ark-ui/solid/toggle-group';
import { splitProps } from 'solid-js';
import { cn } from 'tailwind-variants';
import { Button } from '../forms/button.tsx';
import type { ComponentProps } from 'solid-js';

type ToggleButtonProps = Pick<
	ComponentProps<typeof Button>,
	'action' | 'appearance' | 'rounding' | 'width' | 'size' | 'icon' | 'iconPosition' | 'iconLabel'
>;
type ToggleProps = ComponentProps<typeof AToggle.Root> & ToggleButtonProps;

export function Toggle(props: ToggleProps) {
	const [, buttonProps] = splitProps(props, [
		'action',
		'appearance',
		'rounding',
		'width',
		'size',
		'icon',
		'iconPosition',
		'iconLabel',
	]);
	return (
		<AToggle.Root
			asChild={(p) => (
				// @ts-expect-error too complex
				<Button {...p()} {...buttonProps} />
			)}
			{...props}
		/>
	);
}

export function ToggleGroup(props: ComponentProps<typeof AToggleGroup.Root>) {
	return (
		<AToggleGroup.Root
			{...props}
			class={cn(
				'flex items-stretch justify-start *:-ms-px *:rounded-none *:first:rounded-s-full *:last:rounded-e-full',
				props.class,
			)}
		/>
	);
}

ToggleGroup.Item = function ToggleGroupItem(props: ComponentProps<typeof AToggleGroup.Item> & ToggleButtonProps) {
	const [, buttonProps] = splitProps(props, [
		'action',
		'appearance',
		'rounding',
		'width',
		'size',
		'icon',
		'iconPosition',
		'iconLabel',
	]);
	return (
		<AToggleGroup.Item
			asChild={(p) => (
				// @ts-expect-error too complex
				<Button {...p()} rounding="md" size="sm" {...buttonProps} />
			)}
			{...props}
		/>
	);
};
